module.exports = __webpack_public_path__ + "static/img/GettyImages-476387962.24bc990.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/looking-ahead/GettyImages-476387962.jpg
// module id = pLFh
// module chunks = 0